module.exports = __webpack_public_path__ + "static/media/butterfieldRobinson.b3859af9.png";